import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Base } from '../../components/RootLayout';
import TopNavigation from '../../components/TopNavigation';
import * as Assets from '../../utils/svg_assets';
import * as PageRoutes from '../../utils/route_pages';

const SuccessSubmitted = () => {
  const navigate = useNavigate();

  return (
    <Base>
      <TopNavigation
        titlePage="RECEIPT SUBMITTED"
        setBorder={true}
        showRightIcon={false}
        showLeftIcon={false}
      />
      <div
        className="container mt-4 d-flex flex-column justify-content-center align-items-center"
        style={{ height: '80vh' }}
      >
        <div className="text-center">
          <h1 className="text-title-main-color-s mb-5">
            Thank you, your receipt <br /> has been submitted
          </h1>
          <img
            src={Assets.snapReceiptNotFound}
            alt="icon_success"
            className="mb-5"
          />
          <div className="fs-14">
            Your receipt submission will be processed<br></br>
            within 3 working days
          </div>
        </div>
        <div className="mt-5 footer w-90">
          <Button
            title="Back to Home"
            className="btn btn-danger"
            onClick={() => {
              navigate(PageRoutes.snapReceipt);
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </Base>
  );
};

export default SuccessSubmitted;
